// eslint-disable-next-line import/no-unresolved
import KeenSlider from './keen-slider-with-wheel.js'

class ProductGallery extends HTMLElement {
  constructor () {
    super()

    this.slidesEl = this.querySelector('[data-el="product-gallery.slides"]')
    this.slideEls = this.querySelectorAll('[data-el="product-gallery.slide"]')
    this.dotEls = this.querySelectorAll('[data-el="product-gallery.dot"]')
    this.thumbEls = this.querySelectorAll('[data-el="product-gallery.thumb"]')
    this.closeEl = this.querySelector(
      '[data-el="product-gallery.closeGallery"]',
    )

    this.photoswipeEl = this.querySelector(
      '[data-el="product-gallery.photoswipe"]',
    )
    this.popupGallery = this.querySelector(
      '[data-el="product-gallery.popupGallery"]',
    )
    this.popupGallerySlidesEl = this.querySelector(
      '[data-el="product-gallery.popupGallerySlides"]',
    )
    this.popupGallerySlideEls = this.querySelectorAll(
      '[data-el="product-gallery.popupGallerySlide"]',
    )

    this.popupGalleryThumbEls = this.querySelectorAll(
      '[data-el="product-gallery.popupGalleryThumb"]',
    )

    this.desktopVideoEl = this.querySelector(
      '[data-el="product-gallery.desktopVideo"]',
    )
    this.mobileVideoEl = this.querySelector(
      '[data-el="product-gallery.mobileVideo"]',
    )

    const desktopVideoBackgroundElement = document.querySelector(
      '.sec-Background_Video-desktop source',
    )
    const mobileVideoBackgroundElement = document.querySelector(
      '.sec-Background_Video-mobile source',
    )
    this.desktopVideoBackgroundSource = desktopVideoBackgroundElement
      ? desktopVideoBackgroundElement.src
      : null
    this.mobileVideoBackgroundSource = mobileVideoBackgroundElement
      ? mobileVideoBackgroundElement.src
      : null

    if (this.desktopVideoEl && this.desktopVideoBackgroundSource) {
      this.desktopVideoEl
        .querySelector('source')
        .setAttribute('src', this.desktopVideoBackgroundSource)
      this.desktopVideoEl.load()
    }

    // if (this.slideEls.length < 2) return

    this.slideEls.forEach((el, index) => {
      el.addEventListener('click', () => {
        const slideIndex = Number(el.dataset.slideIndex ?? el.dataset.slide ?? index)
        this.popupGalleryOpen(Number.isNaN(slideIndex) ? index : slideIndex, el)
      })
    })

    this.popupGalleryThumbEls.forEach(popupGalleryThumbEl => {
      popupGalleryThumbEl.addEventListener('click', event => {
        this.popupGalleryGoToSlide(event.currentTarget.dataset.slide)
      })
    })

    this.dotEls.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.carousel?.moveToSlide(dot.dataset.slide)
      })
    })
    this.thumbEls.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        this.carousel?.moveToSlide(parseInt(thumb.dataset.slide, 10))
      })
    })

    this.carousel = null
    this.refreshCarousel()

    this.mediaQuery = window.matchMedia('(min-width: 901px)')
    this.mediaQuery.addEventListener('change', () => {
      this.refreshCarousel()
    })
    window.addEventListener('resize', () => {
      window.clearTimeout(this.resizeTimer)
      this.resizeTimer = window.setTimeout(() => {
        this.refreshCarousel()
      }, 100)
    })
  }

  isVisible () {
    return this.getClientRects().length > 0
  }

  refreshCarousel () {
    if (!this.slidesEl || !this.slideEls.length) return
    if (this.slidesEl.classList.contains('prd-Gallery_Items--scroll')) return

    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    if (!this.isVisible()) return

    this.carousel = this.initialiseCarousel()
  }

  popupGalleryOpen (slideIndex, thumbEl) {
    if (!this.photoswipeEl || !window.PhotoSwipe) return

    const images = JSON.parse(this.photoswipeEl.dataset.images)
    const size = {
      width: 1326,
      height: 1800,
    }
    const isMobile = window.matchMedia('(max-width: 900px)').matches

    this.gallery = new window.PhotoSwipe(
      this.photoswipeEl,
      window.PhotoSwipeUI_Default,
      images.map(image => ({
        src: window.BAO.utils.resizeImage({
          src: image,
          size: `${size.width}x${size.height}`,
        }),
        w: size.width,
        h: size.height,
      })),
      isMobile
        ? {
            index: slideIndex,
            history: false,
            focus: false,
            modal: true,
            closeOnScroll: false,
            closeOnVerticalDrag: true,
            pinchToClose: true,
            tapToToggleControls: true,
            showHideOpacity: true,
            showAnimationDuration: 220,
            hideAnimationDuration: 180,
            maxSpreadZoom: 2,
            loop: true,
            getThumbBoundsFn: index => {
              const slide = this.slideEls[index] || thumbEl
              const img = slide && slide.querySelector('img')
              if (!img) return { x: 0, y: 0, w: 0 }
              const rect = img.getBoundingClientRect()
              return {
                x: rect.left,
                y: rect.top + (window.pageYOffset || document.documentElement.scrollTop),
                w: rect.width,
              }
            },
          }
        : { index: slideIndex },
    )

    const pswpHost = this.photoswipeEl
    const pswpParent = pswpHost.parentNode
    const pswpNext = pswpHost.nextSibling
    document.body.appendChild(pswpHost)

    this.gallery.init()

    this.gallery.listen('destroy', () => {
      if (pswpNext && pswpNext.parentNode === pswpParent) {
        pswpParent.insertBefore(pswpHost, pswpNext)
      } else if (pswpParent) {
        pswpParent.appendChild(pswpHost)
      }
    })

    this.gallery.listen('afterChange', () => {
      const currentIndex = Number(this.gallery.getCurrentIndex())
      this.popupGalleryThumbEls.forEach((popupGalleryThumbEl, index) => {
        popupGalleryThumbEl.setAttribute('aria-current', index === currentIndex)
      })
    })
  }

  initialiseCarousel () {
    if (!this.slidesEl || !this.slideEls.length) return null

    return new KeenSlider(this.slidesEl, {
      duration: 0,
      loop: true,
      slides: this.slideEls.length,
      move: instance => {
        this.slideEls.forEach((slide, index) => {
          slide.setAttribute(
            'aria-hidden',
            index !== instance.details().relativeSlide,
          )
        })
      },
      created: instance => {
        const current = instance.details().relativeSlide
        this.thumbEls.forEach(thumb => {
          thumb.setAttribute(
            'aria-current',
            parseInt(thumb.dataset.slide) === current,
          )
        })
      },
      slideChanged: instance => {
        this.dotEls.forEach(dot => {
          dot.setAttribute(
            'aria-current',
            parseInt(dot.dataset.slide) === instance.details().relativeSlide,
          )
        })
        this.thumbEls.forEach(thumb => {
          thumb.setAttribute(
            'aria-current',
            parseInt(thumb.dataset.slide) === instance.details().relativeSlide,
          )
        })
      },
    })
  }

  popupGalleryGoToSlide (slideIndex) {
    if (this.gallery) {
      this.gallery.goTo(slideIndex)
    }
  }
}

customElements.define('product-gallery', ProductGallery)